// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AuthBar__authBar__root"};